import {createGlobalStyle} from "styled-components"
import {formHoverColor, headingFont, mainFont} from "../utils/vars"

export default createGlobalStyle`
  html, body, #__next {
    height: 100%;
    width: 100%;
  }
  *, *:before, *:after {
    box-sizing: inherit;
  }
  * {
    padding: 0;
    margin: 0;
    outline: none;
  }
  body {
    font-family: ${mainFont};
    font-weight: 400;
    font-size: 16px;
    line-height: 1.55;
    background: #F4F4F4;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
  }
  p {
    margin: 0;
  }
  a {
    text-decoration: none;
    color: inherit;
  }
  input {
    border: none;
    outline: none;
    font-size: 16px;
    font-family: ${mainFont};
  }
  h1, h2, h3, h4, h5, h6 {
    font-family: ${headingFont};
    font-weight: 700;
    letter-spacing: -0.01em;
    line-height: 1.2;
  }
  h1 {
    font-weight: 800;
    font-size: 50px;
    letter-spacing: -0.02em;
  }
  .ant-row {
    margin: 0;
  }
  .ant-input-textarea > .ant-input-affix-wrapper > textarea {
    font-family: ${mainFont};
    font-size: 14px;
    border: 1px solid gray;
    background-color: gainsboro !important;
    padding: 10px 20px;
    height: 200px;
    resize: none;
  }
  .ant-input:hover, .ant-input-textarea > .ant-input-affix-wrapper > textarea:hover {
    background-color: ${formHoverColor} !important;
  }
`
